export default __webpack_public_path__ + "static/media/print-label-second-position.ffed2af1.svg";